import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {PaymentCategorySystem} from "../../utils/types/payment_categories";
import {transactionPaymentCategory_template} from "./transactionPaymentCategory_template";
import {transactionPaymentCategoryBase_template} from "./transactionPaymentCategoryBase_template";

declare var ko: any;
declare var page: any;

export class transactionPremiumPaymentCategory_template extends transactionPaymentCategoryBase_template {


    protected getTemplateName(): string {
        return "transactionPremiumPaymentCategory_template";
    }

    protected getTemplateHtml(): string {
        return `
            <div id="session-brand-target" class="form-body full-width" >
                <div class="form-group row" style="width: 50%;justify-content: flex-start;">
                    <button class="btn icon i-plus" data-bind="text: 'Add ' + system() + ' Payment Category', event: { click: onAddPaymentCategory }" ></button>
                </div>
                <div class="w-list-results">
                    <table class="list-results">
                        <thead>
                            <tr>
                                <th class="border-right"><span>Payment Category</span></th>
                                <th class="border-right"><span>Writer</span></th>
                                <th class="border-right"><span>Editor</span></th>
                                <th></th>
                                <th></th>
                            </tr>
                            <tr>
                                <th class="border-right"></th>
                                <th class="border-right"><span>Commission</span></th>
                                <th class="border-right"><span>Commission</span></th>
                                <th><span>Weight</span></th>
                                <th><span>Status</span></th>
                            </tr>
                        </thead>
                         <tbody data-bind="foreach: paymentCategories">
                            <tr class="brand-row">
                                <td class="border-right">
                                    <!-- ko if: categoryId -->
                                    <h3><span data-bind="text: categoryName"></span></h3>
                                    <!-- /ko -->
                                    <!-- ko ifnot: categoryId -->
                                    <input type="text" style="width: 100%" class="input-text" data-bind="value: categoryName" />
                                    <!-- /ko -->
                                </td>
                                <td class="border-right"><input type="number" class="input-text" data-bind="value: writerCommissionAmount"></td>
                                <td class="border-right"><input type="number" class="input-text" data-bind="value: editorCommissionAmount"></td>
                                <td><input type="number" class="input-text" data-bind="value: categoryWeight"></td>
                                <td>
                                    <!-- ko if: categoryId -->
                                    <input type="checkbox" class="input-text" data-bind="checked: isDeleted, attr: {id: 'payment-category-' + categoryId }" />
                                    <label class="form-label icon i-check" data-bind="attr: {for: 'payment-category-' + categoryId }">Is Inactive</label>
                                    <!-- /ko -->

                                    <!-- ko ifnot: categoryId -->
                                    <button class="btn icon i-delete" data-bind="event: { click: onRemovePaymentCategory }, attr: {id: 'payment-category-' + categoryId }"></button>
                                    <!-- /ko -->
                                </td>
                            </tr>
                         </tbody>
                  </table>
               </div>

               <div class="form-footer">
                  <button class="btn" data-bind="event: { click: onClickCancel }, text: 'Cancel'" >Save</button>
                  <button class="btn highlight" data-bind="event: { click: onClickSave }, text: 'Save'" >Save</button>
               </div>
            </div>
        `;
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/transactionPremiumPaymentCategory_template.ts